const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  centred: {
    width: '100%',
    maxWidth: '1320px',
    alignSelf:'center',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  flex: {
    flex: 1,
    fontWeight: 300,
    fontSize: 15,
  },
  button: {
    margin: theme.spacing.unit,
    color: 'white',
    margin: 0,
    padding: 0,
    minWidth: 'initial',
    '&:focus': {
      outline: 'none'
    }
  },
})

export default styles
